import { Check } from 'lucide-react'

import { Banner } from '@/components/ui/banner'
import { MATCHED_BROKER } from '../../navFixtures'

/** What happens next once everything is in; the prototype stops here rather than flipping to active. */
export function CoverageActivation({
  coverageNames,
  startDate,
}: {
  coverageNames: string
  startDate: string
}) {
  return (
    <Banner variant="info" small icon={<Check />} className="mt-3 lg:max-w-[400px]">
      <p className="font-semibold">Your coverage is ready to activate!</p>
      <p>
        {coverageNames} will be activated on {startDate}.
      </p>
      <p className="mt-2">
        Need to change something or cancel?{' '}
        <a href={`mailto:${MATCHED_BROKER.email}`} className="font-semibold underline underline-offset-2">
          Reach out to {MATCHED_BROKER.name}
        </a>
      </p>
    </Banner>
  )
}
